import { useQuery } from "@tanstack/react-query";
import { dropdownService } from "../api/services/dropdownService";

export const useScreenOptions = () => {
  const {
    data: screenOptions,
    isLoading: isScreenOptionsLoading,
    refetch: refetchScreenOptions,
  } = useQuery({
    queryKey: ["screenOptions"],
    queryFn: () => dropdownService.getScreenOptions(),
  });

  return {
    screenOptions: screenOptions || [],
    isScreenOptionsLoading,
    refetchScreenOptions,
  };
};
